import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import PayoutList from "./PayoutList";

const PayoutListLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Payout List" />
      <PayoutList />
    </MasterLayout>
  );
};

export default PayoutListLayout;
